import Text from '@creator/ui/components/Text/Text';
import { cn } from '@creator/ui/utils/ui';
import CommentList from '@src/components/Post/CommentList/CommentList';
import { memo } from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface CommentsSectionProps {
    tokenName: string;
    postId: string;
    className?: string;
    highlightCommentId?: string;
}

const CommentsSection: FC<CommentsSectionProps> = props => {
    const { className = '', postId, highlightCommentId = '', tokenName } = props;

    const { t } = useTranslation();

    function renderComments() {
        return <CommentList includeReplies={true} fetchLimit={5} highlightCommentId={highlightCommentId} className="" tokenName={tokenName} type="post" postId={postId} />;
    }

    function renderTitle() {
        return <Text className="block px-4 pt-1 pb-2 text-sm font-bold">{t('commentsSection.title')}</Text>;
    }

    return (
        <div className={cn('divide-y divide-gray-200 dark:divide-gray-800', className)}>
            {renderTitle()}
            {renderComments()}
        </div>
    );
};

export default memo(CommentsSection);
